import { useQuery } from "@tanstack/react-query";
import { getSection } from "../services/mapServices";
import { FIVE_MINUTES_IN_MS } from "../configuration/globalConstants";
import { useSessionStore } from "../store/sessionStore";

export function useSection(sectionId){
    const { motion }= useSessionStore()
    const id = sectionId ?? motion?.section

    return useQuery({
        queryKey: ['section', { id }],
        queryFn: () => getSection(id),
        staleTime: FIVE_MINUTES_IN_MS,
        enabled: !!id,
    })
}